import Lottie from 'lottie-react';
import { useEffect } from 'react';
import { CelebrationType } from 'src/lib/enum';

import { Box, Typography } from '@mui/material';

import animationData from '../assets/animations/Animation.json';
import { trackNewReferralToast } from '../lib/mixpanel';
import { AffiliateRes } from '../lib/types';

interface FullScreenCelebrationProps {
  onClose: () => void;
  duration?: number;
  type: CelebrationType;
  transactionCount?: number;
  totalAmount?: string;
  affiliateId?: string;
  affiliate?: AffiliateRes;
  phoneNumber?: string;
}

const FullScreenCelebration = ({
  onClose,
  duration = 6000,
  type,
  transactionCount = 0,
  totalAmount = '',
  affiliateId,
  affiliate,
  phoneNumber
}: FullScreenCelebrationProps) => {
  useEffect(() => {
    if (type === 'referral' && affiliateId) {
      trackNewReferralToast(affiliateId, transactionCount, totalAmount, affiliate);
    }

    const timer = setTimeout(() => {
      onClose();
    }, duration);
    return () => clearTimeout(timer);
  }, [onClose, duration, type, affiliateId, transactionCount, totalAmount, affiliate]);

  const getCelebrationContent = () => {
    switch (type) {
      case 'referral':
        return (
          <>
            🚀 Boom!
            <br />{transactionCount} new {transactionCount === 1 ? 'transaction' : 'transactions'} = {totalAmount} earned.
            <br />Share your code again and watch it grow.
          </>
        );
      case 'phoneUpdate':
        return (
          <>
            ✅ Phone Number Updated!
            <br />
            <br />
            Next time you sign in, use your phone number:
            <br />
            <strong>{phoneNumber}</strong>
            <br />
            <br />
            This will help us verify your account faster.
          </>
        );
      case 'phoneVerification':
        return (
          <>
            ✅ Phone Number Verified!
            <br />
            <br />
            Your phone number has been successfully verified:
            <br />
            <strong>{phoneNumber}</strong>
            <br />
            <br />
            You can now use your phone number for faster sign-ins.
          </>
        );
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        bgcolor: 'rgba(0,0,0,0.35)',
        zIndex: 2000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}
    >
      <Box sx={{
        width: { xs: 260, sm: 400, md: 500 },
        height: { xs: 260, sm: 400, md: 500 },
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
      }}
      >
        <Lottie animationData={animationData} loop autoplay style={{ width: '100%', height: '100%' }} />
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          textAlign: 'center',
          zIndex: 10,
          color: 'white',
          textShadow: '2px 2px 4px rgba(0,0,0,0.8)',
          width: '90%'
        }}
        >
          <Typography
            variant="subtitle1"
            sx={{
              fontWeight: 600,
              fontSize: { xs: '16px', sm: '20px', md: '24px' },
              lineHeight: 1.3,
              display: 'inline-block'
            }}
          >
            {getCelebrationContent()}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default FullScreenCelebration; 